// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__185Wp","title":"Header_title__3Vp5a","left":"Header_left__3RIMx","clinicName":"Header_clinicName__YqJd7"};